import { useTheme } from '@mui/material/styles';
import { Link } from 'gatsby';
import React, { memo } from 'react';
import { useLocation } from 'react-use';

import MenuItem from '@components/MenuItem';

import { RECORD_NAMES, RECORD_URLS } from '@constants/urls-and-types';

import { resolveIcon } from '@utils/resolveIcon';

interface RecordMenuItemProps {
  recordType: keyof typeof RECORD_URLS;
  notifications?: number;
  since?: Date;
  onClick?: React.MouseEventHandler;
}

const RecordMenuItem: React.FC<RecordMenuItemProps> = ({
  recordType,
  since,
  notifications = 0,
  onClick,
}) => {
  const location = useLocation();

  const theme = useTheme();

  const pathname = location.pathname?.endsWith('/')
    ? location.pathname
    : location.pathname?.concat('/');

  // const hasRecent = Math.random() > 0.5;

  // eslint-disable-next-line no-inline-comments
  if (since /* && !hasRecent */) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    onClick?.(e);
  };

  return (
    <Link
      data-testid="record-menu-item-link"
      key={recordType}
      to={RECORD_URLS[recordType]}
      onClick={handleClick}
    >
      <MenuItem
        notifications={notifications}
        selected={pathname?.includes(RECORD_URLS[recordType])}
        text={RECORD_NAMES[recordType]}
        {...resolveIcon(recordType, theme)}
      />
    </Link>
  );
};

export default memo(RecordMenuItem);
